import { useEffect, useState } from "react";
import useGroupsContext from "hooks/useGroupsContext";
import logEvent from "utils/logEvent";
import Loader from "components/Loader/Loader";
import NoDataWrapper from "components/NoDataWrapper";
import * as Components from "../Groups.components";
import GroupsTable from "../GroupsTable";
import MultiSelectProvider from "providers/MultiSelectProvider";
import MuiThemeProvider from "components/MuiThemeProvider";
import NoDataFallback from "./components/NoDataFallback";
import TableSortProvider from "providers/TableSortProvider";

function GroupsContent() {
  const [loading, setLoading] = useState(false);
  const [groups, { fetchAll: fetchAllGroups }] = useGroupsContext();

  useEffect(() => {
    (async () => {
      try {
        logEvent("GROUPS_VIEW_ALL");
        setLoading(true);
        await fetchAllGroups();
      } catch (e) {}
      setLoading(false);
    })();
  }, [fetchAllGroups]);

  return (
    <MuiThemeProvider>
      <Components.GroupContentDiv sx={{ p: 0, height: "100%" }}>
        <NoDataWrapper hasData={Boolean(groups.length)} fallback={<NoDataFallback />}>
          <MultiSelectProvider>
            <TableSortProvider initialSortKey="name" initialDirection="asc">
              <GroupsTable groups={groups} />
            </TableSortProvider>
          </MultiSelectProvider>
        </NoDataWrapper>
      </Components.GroupContentDiv>
      {loading && <Loader />}
    </MuiThemeProvider>
  );
}

export default GroupsContent;
